import { render, staticRenderFns } from "./home_advantages.vue?vue&type=template&id=ba24fec6&scoped=true&"
import script from "./home_advantages.vue?vue&type=script&lang=js&"
export * from "./home_advantages.vue?vue&type=script&lang=js&"
import style0 from "./home_advantages.vue?vue&type=style&index=0&id=ba24fec6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba24fec6",
  null
  
)

export default component.exports